import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="navbar">
      <Link to="/" style={{ textDecoration: 'none', color: '#3e2723' }}>
        <h2 className="brand-font">La Provence Bakery</h2>
      </Link>
      <div className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/menu">Our Menu</Link> {/* Link Baru */}
        <Link to="/location">Location & Hours</Link>
        <Link to="/contact">Contact Us</Link>
      </div>
    </nav>
  );
}

export default Navbar;